import { z } from 'zod';

export const VideosSchema = z.object({
    videos: z.array(
        z.strictObject({
            id: z.string(),
            src: z.string(),
            thumbnail: z.string().optional(),
        }),
    ),
});
